<template>
  <FormDevice :data="form" :key="componentKey" />
</template>

<script>
import FormDevice from './components/FormDevice';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: { FormDevice },
  data () {
    return {
      success: false,
      form: {
        code: Math.random().toString(36).substr(2, 6),
        name: null,
        rememberRules: 0,
        maxRememberTime: 30
      },
      componentKey: 0,
    }
  },
  computed: {
    ...mapState('visitManagement', ['device'])
  },
  methods: {
    onSuccess (form) {
      console.log('SUCCESS', form)
      this.success = true
    },
    async fetchDevice() {
      await this.$store.dispatch(
        'visitManagement/fetchDevice',
        this.$route.query.deviceId
      ).then(res => {

        console.log ('=fetchDevice=',res);
        let clonedLocation = cloneDeep(res);
        
      });
    }
  },
  async created () {
    if (this.$route.query.deviceId) {
      await this.fetchDevice();
    }
    this.$store.commit('visitManagement/SET_DEVICE', {});
    this.componentKey += 1;
  },
  beforeRouteLeave (to, from, next) {
    if ((this.device || {}).id) return next();
    this.$vs.dialog({
      type: 'confirm',
      title: 'Unsaved changes',
      text: 'You have unsaved changes. Do you want to leave the page without saving?',
      acceptText: 'Yes, Leave',
      accept: () => next(),
      cancel: () => next(false)
    })
  }
}
</script>
